import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  set as setSearch
} from 'store/redux/search'
import { mapActivityData } from 'utils/activities'
import camelCaseKeys from 'utils/camelCaseKeys'
import { AuthError } from '@kanbo/api'

export default function * fetchSearchComments (action) {
  const { refresh, boardId, limit } = action.payload

  if (refresh) {
    yield put(setSearch({
      comments: [],
      commentsCursor: null,
      commentsTotalCount: null,
      commentsLoadedAll: false,
      commentsLoading: true
    }))
  } else {
    yield put(setSearch({
      commentsLoading: true
    }))
  }

  const state = yield select()

  const { query, limitToBoard, refiners, comments, commentsCursor, commentsSort } = state.kanbo.search

  try {
    const { Results, Cursor, Refiners, SortOptions, TotalRows } = yield call(apiGetData, 'SearchMessages', {
      query,
      cursor: commentsCursor,
      limit,
      sort: commentsSort,
      boardIds: (boardId && limitToBoard) ? [boardId] : undefined,
      refiners: Object.keys(refiners.comments).map(key => ({
        id: key,
        ...refiners.comments[key]
      })),
    })

    yield put(setSearch({
      comments: [
        ...comments,
        ...Results.map(Comment => ({
          id: Comment.Id,
          cardId: Comment.CardId,
          activity: mapActivityData({
            Id: Comment.Id,
            From: Comment.From,
            Tags: Comment.Tags,
            Timestamp: Comment.CreateTimestamp,
            JsonMessage: Comment.JsonMessage,
          }),
          highlight: Comment.Highlight && {
            html: Comment.Highlight.HighlightHtml,
            type: Comment.Highlight.Type
          },
        }))
      ],
      commentsCursor: Cursor,
      commentsRefiners: Refiners ? camelCaseKeys(Refiners) : [],
      commentsSortOptions: SortOptions ? camelCaseKeys(SortOptions) : [],
      commentsTotalCount: TotalRows,
      commentsLoadedAll: !Cursor,
      commentsLoading: false
    }))
  } catch (error) {
    if (error instanceof AuthError) {
      yield put(setSearch({
        commentsLoadedAll: true,
        commentsLoading: false,
      }))
    } else {
      yield put(setSearch({
        commentsLoading: false
      }))

      throw error
    }
  }
}
